import { render } from "./StatusReportQuestionList.vue?vue&type=template&id=cc2bfeee"
import script from "./StatusReportQuestionList.vue?vue&type=script&lang=js"
export * from "./StatusReportQuestionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__